import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/salesforce-glyph.vue
var o = {
	name: "DtIconSalesforceGlyph",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--salesforce-glyph"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Salesforce Glyph",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("rect", {
		width: "24",
		height: "24",
		rx: "2",
		fill: "#00A1E0"
	}, null, -1), r("path", {
		d: "M10.323 6.419a3.637 3.637 0 0 1 2.536-1.011c1.32 0 2.472.683 3.085 1.698a4.543 4.543 0 0 1 1.744-.344C20.07 6.762 22 8.57 22 10.8c0 2.231-1.93 4.04-4.312 4.04-.285 0-.57-.027-.849-.08-.54.896-1.57 1.5-2.751 1.5-.494 0-.962-.106-1.379-.295C12.162 17.161 10.886 18 9.4 18c-1.549 0-2.868-.91-3.375-2.186a3.54 3.54 0 0 1-.686.067C3.495 15.88 2 14.479 2 12.749c0-1.16.672-2.172 1.67-2.713a3.368 3.368 0 0 1-.32-1.433c0-1.99 1.739-3.602 3.884-3.602 1.26 0 2.38.556 3.089 1.418Z",
		fill: "#fff"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=salesforce-glyph.js.map